@if (stackedIcon(); as stackedIcon) {
  <span class="fa-stack" [ngClass]="stackedIcon.class">
    @for (icon of stackedIcon.icons; track icon) {
      <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: icon }"></ng-container>
    }
  </span>
} @else if (icon()) {
  <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: icon() }"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="iconTemplate; context: { icon: name() }"></ng-container>
}

<ng-template let-icon="icon" #iconTemplate>
  @switch (icon |iconType) {
    @case ('fa5') {
      <i [class]="icon"></i>
    }
    @case ('fa6') {
      <i [class]="icon"></i>
    }
    @case ('svg') {
      <i [innerHTML]="icon"></i>
    }
    @default {
      <i class="fa-regular fa-ban"></i>
    }
  }
</ng-template>
